import React, { useState } from "react";
import { ColorBoxLabel } from "../../../components/ColorBox";
import { More } from "../../../components/MoreToggle";
import { KV } from "../util";

interface ScoreProps {
  stats: Record<string, number>;
  label: string;
  prop: string;
  sub?: boolean;
  legend: { low: number; color: string; name: string }[];
  children?: React.ReactNode;
}
export const Score = ({ stats, label, prop, legend, sub, children }: ScoreProps) => {
  const value = stats[prop];
  if (value === undefined) return null;
  const elem =
    legend.find((l, index) => value > l.low && value < legend[index + 1]?.low) ||
    legend[legend.length - 1];
  return (
    <KV k={label} sub={sub}>
      <ColorBoxLabel elem={elem}>
        {/* value.toFixed(2)} */}
        {children}
      </ColorBoxLabel>
    </KV>
  );
};

export const StatScores = ({
  stats,
  prefix,
  mapping,
  title,
  legend,
}: {
  stats: Record<string, number>;
  prefix: string;
  mapping: Record<string, string>;
  title: string;
  legend: any[];
}) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <Score stats={stats} label={title} prop={prefix + `score`} legend={legend}>
        <More open={open} setOpen={setOpen} />
      </Score>
      {open &&
        Object.entries(mapping).map(([prop, label], index) => (
          <Score
            sub={true}
            key={index}
            stats={stats}
            label={label}
            prop={prefix + prop}
            legend={legend}
          />
        ))}
    </>
  );
};
